import React from "react";
import { useLanguage } from "../utils/i18n";

export function TermsModal({ onClose }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 2000,
      background: "rgba(15,23,42,0.55)", backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "24px",
    }} onClick={onClose}>
      <div style={{
        background: "#fff", borderRadius: 18, maxWidth: 680, width: "100%",
        maxHeight: "85vh", overflowY: "auto",
        padding: "40px 44px", boxShadow: "0 24px 80px rgba(0,0,0,0.18)",
        position: "relative",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{
          position: "absolute", top: 18, right: 20,
          background: "none", border: "none", fontSize: 22,
          cursor: "pointer", color: "#94a3b8", lineHeight: 1,
        }}>×</button>

        <h1 style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>Terms &amp; Conditions</h1>
        <p style={{ fontSize: 12, color: "#94a3b8", marginBottom: 28 }}>Last updated: March 2026</p>

        {[{
          title: "1. Acceptance of Terms",
          body: "By creating an account or using NoteMila (\"the Service\"), you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the Service."
        }, {
          title: "2. Description of Service",
          body: "NoteMila provides AI-powered study tools including textbook explanation, live lecture translation, and note management. The Service is intended for personal, non-commercial educational use."
        }, {
          title: "3. Subscription & Pricing",
          body: "Access to premium features requires an active paid subscription. We reserve the right to change subscription pricing at any time. We will provide reasonable notice of price changes via email or in-app notification. Continued use of the Service after a price change constitutes acceptance of the new pricing."
        }, {
          title: "4. Usage Limits",
          body: "We reserve the right to introduce, modify, or enforce usage limits on any feature of the Service at any time, including but not limited to the number of AI queries, translations, note entries, or file uploads. Limits may vary by subscription tier and may be adjusted without prior notice to ensure fair use and service stability."
        }, {
          title: "5. Free Trial",
          body: "We may offer a free trial period. At the end of the trial, your subscription will automatically convert to a paid plan unless you cancel before the trial expires. You may cancel at any time through your account settings."
        }, {
          title: "6. Intellectual Property",
          body: "All content you upload or generate through the Service remains your property. By uploading content, you grant NoteMila a limited licence to process that content solely for the purpose of providing the Service to you. NoteMila's software, branding, and AI models are proprietary and may not be copied or reverse-engineered."
        }, {
          title: "7. Acceptable Use",
          body: "You agree not to use the Service for unlawful purposes, to upload content that infringes third-party rights, or to attempt to circumvent any security or access controls. We reserve the right to suspend or terminate accounts that violate these terms."
        }, {
          title: "8. Data & Privacy",
          body: "We collect and process personal data as described in our Privacy Policy. We use AWS infrastructure and apply reasonable security measures to protect your data. We do not sell your personal information to third parties."
        }, {
          title: "9. Disclaimer of Warranties",
          body: "The Service is provided \"as is\" without warranties of any kind. AI-generated content is for reference only and may contain errors. NoteMila does not guarantee the accuracy, completeness, or suitability of any AI output for academic or professional purposes."
        }, {
          title: "10. Limitation of Liability",
          body: "To the maximum extent permitted by law, NoteMila shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service, including but not limited to loss of data or academic outcomes."
        }, {
          title: "11. Changes to Terms",
          body: "We may update these Terms at any time. We will notify users of material changes via email or in-app notice. Continued use of the Service after changes have been posted constitutes your acceptance of the revised Terms."
        }, {
          title: "12. Governing Law",
          body: "These Terms are governed by the laws of Victoria, Australia. Any disputes shall be subject to the exclusive jurisdiction of the courts of Victoria."
        }, {
          title: "13. Contact",
          body: "For questions about these Terms, please contact us at support@notemila.com."
        }].map(({ title, body }) => (
          <div key={title} style={{ marginBottom: 22 }}>
            <h3 style={{ fontSize: 13.5, fontWeight: 700, color: "#1e293b", marginBottom: 6 }}>{title}</h3>
            <p style={{ fontSize: 13, color: "#475569", lineHeight: 1.7, margin: 0 }}>{body}</p>
          </div>
        ))}

        <div style={{ marginTop: 32, paddingTop: 20, borderTop: "1px solid #e2e8f0", textAlign: "center" }}>
          <button onClick={onClose} style={{
            background: "linear-gradient(135deg,#2563eb,#1d4ed8)", color: "#fff",
            border: "none", borderRadius: 10, padding: "10px 32px",
            fontSize: 13, fontWeight: 700, cursor: "pointer",
          }}>Close</button>
        </div>
      </div>
    </div>
  );
}

export function PrivacyPolicyModal({ onClose }) {
  const section = (title, body) => (
    <div key={title} style={{ marginBottom: 22 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginBottom: 6 }}>{title}</h3>
      <p style={{ fontSize: 13, color: "#475569", lineHeight: 1.7, margin: 0 }}>{body}</p>
    </div>
  );
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 2000,
      background: "rgba(15,23,42,0.55)", backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "24px",
    }} onClick={onClose}>
      <div style={{
        background: "#fff", borderRadius: 18, maxWidth: 680, width: "100%",
        maxHeight: "85vh", overflowY: "auto", padding: "40px 44px",
        boxShadow: "0 24px 80px rgba(0,0,0,0.18)", position: "relative",
        fontFamily: "'Inter',-apple-system,sans-serif",
      }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{
          position: "absolute", top: 18, right: 20, background: "none",
          border: "none", fontSize: 22, cursor: "pointer", color: "#94a3b8",
        }}>×</button>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>Privacy Policy</h1>
        <p style={{ fontSize: 12, color: "#94a3b8", marginBottom: 28 }}>Last updated: March 2026</p>
        {section("1. Overview",
          "NoteMila ('we', 'us', or 'our') is committed to protecting your personal information. This Privacy Policy explains what data we collect, how we use it, and your rights regarding that data when you use our web application available at notemila.com."
        )}
        {section("2. Information We Collect",
          "We collect information you provide directly: your email address and password when you register; uploaded PDF files and notes you create within the app. We also automatically collect usage data such as pages visited, features used, and device/browser information to improve our service."
        )}
        {section("3. How We Use Your Information",
          "We use your data to: provide and operate the NoteMila service; authenticate your account; process payments via Stripe; deliver AI-powered features (summaries, translations, quizzes, chat); send transactional emails (e.g. verification codes); and improve the product through aggregated analytics."
        )}
        {section("4. Data Storage & Security",
          "Your data is stored on AWS infrastructure in the ap-southeast-2 (Sydney) region. We use industry-standard encryption in transit (TLS) and at rest. Passwords are never stored in plain text — authentication is handled by AWS Cognito. While we take reasonable precautions, no system is completely secure."
        )}
        {section("5. Third-Party Services",
          "We use the following third-party providers: AWS (Cognito, DynamoDB, S3, Lambda) for infrastructure; Stripe for payment processing; OpenAI for AI features. Each provider has their own privacy policy. We do not sell your personal data to any third party."
        )}
        {section("6. File Uploads",
          "PDF files you upload are stored securely in AWS S3 and used solely to generate AI-assisted study content for your account. We do not share or analyse your files beyond what is needed to deliver the features you request."
        )}
        {section("7. Data Retention",
          "We retain your account data for as long as your account is active. Uploaded files are retained until you delete them or close your account. If you cancel your subscription, your data remains accessible until you request deletion."
        )}
        {section("8. Your Rights",
          "You have the right to: access the personal data we hold about you; request correction of inaccurate data; request deletion of your account and data; withdraw consent for data processing. To exercise these rights, contact us at support@notemila.com."
        )}
        {section("9. Cookies",
          "We use session cookies and local storage to keep you logged in and remember your preferences. We do not use third-party advertising cookies. You can disable cookies in your browser settings, but this may affect app functionality."
        )}
        {section("10. Children's Privacy",
          "NoteMila is not directed to children under 13 years of age. We do not knowingly collect personal information from children. If you believe we have inadvertently collected such information, please contact us immediately."
        )}
        {section("11. Changes to This Policy",
          "We may update this Privacy Policy from time to time. We will notify you of significant changes by displaying a notice in the app or by email. Continued use of NoteMila after changes take effect constitutes acceptance of the updated policy."
        )}
        {section("12. Contact",
          "If you have any questions about this Privacy Policy, please contact us at support@notemila.com."
        )}
        <div style={{ borderTop: "1px solid #e2e8f0", paddingTop: 20, marginTop: 8, textAlign: "right" }}>
          <button onClick={onClose} style={{
            background: "#2563eb", color: "#fff", border: "none",
            borderRadius: 10, padding: "10px 28px", fontWeight: 700,
            fontSize: 14, cursor: "pointer",
          }}>Close</button>
        </div>
      </div>
    </div>
  );
}

export function AppFooter({ onShowTerms, onShowPrivacy }) {
  const { t } = useLanguage();
  return (
    <footer style={{
      flexShrink: 0,
      padding: "14px 24px",
      textAlign: "center",
      fontSize: 12,
      color: "#94a3b8",
    }}>
      &copy; 2026 NoteMila &nbsp;&middot;&nbsp;{" "}
      <button
        onClick={onShowTerms}
        style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer", textDecoration: "underline", padding: 0 }}
      >
        {t("termsOfService")}
      </button>
      {" "}&nbsp;&middot;&nbsp;{" "}
      <button
        onClick={onShowPrivacy}
        style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer", textDecoration: "underline", padding: 0 }}
      >
        {t("privacyPolicy")}
      </button>
      {" "}&nbsp;&middot;&nbsp;{" "}
      <a href="mailto:support@notemila.com" style={{ fontSize: 12, color: "#64748b", textDecoration: "underline" }}>
        support@notemila.com
      </a>
    </footer>
  );
}
